import { Student } from 'types/student.types'
import { getClassLevel } from 'utils/profiles'

interface ClassLevelDisplayProps {
  tutor: Student
}

export const ClassLevelDisplay = (props: ClassLevelDisplayProps) => {
  const { tutor } = props

  // TA Draft's roster names the year outright ("Senior", "Grad student"); a grad student's
  // class year alone would read as an undergrad's
  if (tutor?.year) return <>{/grad/i.test(tutor.year) ? 'grad' : tutor.year.toLowerCase()}</>

  return <>{getClassLevel(tutor?.classOf)}</>
}
